import Cookie from 'js-cookie';

import { uuidv4 } from '../../utils/generic';

import { generateSessionId } from './session_id_generator';

const caller_id = 'experts-ui';

export const appendSessionIdHeader = async (headers = {}) => {
  const session_id = await generateSessionId(caller_id);

  if (session_id) {
    headers['x-session-id'] = session_id;
  }
};

export const apiHeaders = (req_data = {}) => {
  let access_token;
  let headers = {
    caller_id: caller_id,
    'Content-Type': 'application/json',
    'X-Request-Id': `experts_ui_${uuidv4()}`
  };

  if (typeof window !== 'undefined') {
    access_token = Cookie.get('access-token');
  } else {
    access_token = req_data.cookies?.['access-token'];
  }

  if (access_token) {
    headers = {
      ...headers,
      'access-token': access_token
    };
  }

  return headers;
};

export const setCurrentTimestampDelta = async () => {
  let current_timestamp_delta = sessionStorage.getItem('current_timestamp_delta');

  if (!current_timestamp_delta) {
    let headers = {
      caller_id: caller_id,
      'x-caller-id': caller_id,
      'x-client-uid': 'core'
    };
    const url = `${process.env.AUTH_BFF_API_URL}api/v1/config/get_config`;

    try {
      const res = await fetch(url, {
        method: 'GET',
        headers
      });
      const result = await res.json();
      const server_timestamp = result?.data?.current_timestamp;

      if (server_timestamp) {
        // Calculate the difference in milliseconds between local time and the ist time for server_timestamp

        const local_time = Date.now();
        const formattedTimestamp = server_timestamp.replace(' ', 'T').replace(' UTC', 'Z');
        const system_timestamp = new Date(formattedTimestamp);

        console.log('system_timestamp: ', system_timestamp);

        // Get system timezone offset from UTC in minutes
        const system_offset_minutes = new Date().getTimezoneOffset(); // e.g., -60 for GMT+1

        // Calculate IST offset from UTC in minutes
        const ist_offset_minutes = -330; // IST = UTC+5:30 → -330 minutes

        //Find the difference between system timezone and IST
        const offset_difference_minutes = system_offset_minutes - ist_offset_minutes; //for finding the ist time for server_timestamp
        const ist_timestamp = new Date(system_timestamp.getTime() + offset_difference_minutes * 60000);

        // Calculate the difference in milliseconds between local time and IST server timestamp

        const current_timestamp_delta = ist_timestamp - local_time;

        sessionStorage.setItem('current_timestamp_delta', current_timestamp_delta);
      } else {
        console.error('Error fetching timestamp from auth', result);
      }
    } catch (err) {
      console.error('Auth API Failed:', err);
    }
  }
};
